import React from "react";
import "./Book.css";

const Book = () => {
  return (
    <>
      <div className="book-scene">
        <div className="book-wrap">
          <div className="left-side">
            <div className="book-cover-left"></div>
            <div className="layer1">
              <div className="page-left"></div>
            </div>
            <div className="layer2">
              <div className="page-left"></div>
            </div>
            <div className="layer3">
              <div className="page-left"></div>
            </div>
            <div className="layer4">
              <div className="page-left"></div>
            </div>
            <div className="layer-text">
              <div className="page-left-2">
                <div className="corner"></div>
                <div className="corner2"></div>
                <div className="corner-fold"></div>
                <div className="page-text w-richtext">
                  <h3>
                    <strong>Bhaskar.</strong>
                  </h3>
                  <h6>
                    <span>Know me!!</span>
                  </h6>
                  <figure className="about-banner">
                    <img
                      src="./assets/images/hero-banner3.png"
                      alt="A man in a alice blue shirt with a thinking expression"
                      className="w-100"
                    />
                    <img
                      src="./assets/images/signature.gif"
                      alt=""
                      className="w-100"
                    />
                  </figure>
                </div>
              </div>
            </div>
          </div>
          <div className="centerr"></div>
          <div className="right-side">
            <div className="book-cover-right"></div>
            <div className="layer1">
              <div className="page-right"></div>
            </div>
            <div className="layer2 right">
              <div className="page-right"></div>
            </div>
            <div className="layer3 right">
              <div className="page-right"></div>
            </div>
            <div className="layer4 right">
              <div className="page-right"></div>
            </div>
            <div className="layer-text right">
              <div className="page-right-2">
                <div className="page-text w-richtext">
                  <h3>
                    <strong>About Me</strong>
                  </h3>
                  <h6>
                    <span>BHASKAR ACHARJEE</span>
                  </h6>
                  <p>
                    <br />
                    Hello! I’m <b>Bhaskar Acharjee</b>, a highly motivated and
                    diligent individual pursuing a Bachelor of Technology degree
                    in
                    <b> Electronics and Communication</b> at
                    <b> Jalpaiguri Government Engineering College</b>. <br />
                    With a strong academic record and proficiency in programming
                    languages like Java, Python, C/C++, and SQL. I have
                    developed Web & Android applications and also gained
                    expertise in Data visualization. Additionally, I actively
                    contribute to the Training and Placement Cell as a role of
                    Placement Coordinator. <br />
                    <br />
                    With my strong educational background, technical skills, and
                    leadership experiences, I am well-prepared to take on
                    challenges and contribute effectively to any professional
                    setting relevant with my work profile. ‍
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Book;
